import { useState, useEffect } from 'react';
import './OneClick.css';

function OneClick({ onClose, title, colors = [] }) {
    // Устанавливаем значение color по умолчанию равным id первого цвета, если массив не пуст
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        description: title,
        agreement: false,
        color: colors.length > 0 ? colors[0].id : '', // Выбираем первый цвет по умолчанию
    });

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Если массив цветов изменяется, обновляем начальное значение цвета
        if (colors.length > 0 && !formData.color) {
            setFormData((prev) => ({ ...prev, color: colors[0].id }));
        }
    }, [colors]); // Обновляем состояние, если colors изменится

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleColorChange = (e) => {
        console.log('Selected color:', e.target.value);
        setFormData((prev) => ({
            ...prev,
            color: e.target.value, // Обновляем выбранный цвет
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Имя обязательно';
        if (!formData.phone) newErrors.phone = 'Телефон обязателен';
        if (!formData.email) newErrors.email = 'Email обязателен';
        if (!formData.agreement) newErrors.agreement = 'Вы должны согласиться с условиями';
        if (!formData.color) newErrors.color = 'Выберите цвет';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const form = e.target;
        const formData = new FormData(form);

        setIsLoading(true);

        try {
            const response = await fetch('https://helper.gbi-etalon.ru/send', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                console.log('Форма отправлена успешно!');
                setIsSubmitted(true);
                setTimeout(() => onClose(), 3000);
            } else {
                console.log('Ошибка отправки формы');
            }
        } catch (error) {
            console.log('Ошибка:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div
                className="modal fade show"
                id="modal-form-buy"
                tabIndex={-1}
                aria-modal="true"
                role="dialog"
                style={{ display: 'block' }}
            >
                <div className="modal-dialog">
                    <div className="modal-content modal-form js-modal-form">
                        <button
                            aria-label="Close"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            type="button"
                            onClick={onClose}
                        >
                            <svg className="close">
                                <use xlinkHref="/catalog/view/theme/gbiv2/img/icons.svg#close"></use>
                            </svg>
                        </button>
                        <h2>Заказ в 1 клик</h2>

                        {isSubmitted ? (
                            <div className="alert alert-success">
                                Заявка успешно отправлена
                            </div>
                        ) : (
                            <form
                                onSubmit={handleSubmit}
                                className="form-fb"
                                js-x-subject="Заказ в 1 клик"
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    id="guard-form"
                                    name="guard-form"
                                    value="73"
                                    style={{ display: 'none' }}
                                    readOnly
                                />
                                <input type="hidden" name="subject" value="Заказ 1 клик" />

                                <div className="form-item">
                                    <label className="form-label" htmlFor="InputName">
                                        Ваше имя*
                                    </label>
                                    <input
                                        aria-describedby="InputNameHelp"
                                        name="name"
                                        className="form-control"
                                        id="InputName"
                                        placeholder="Иван Петров"
                                        type="text"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                    {errors.name && <div className="text-danger">{errors.name}</div>}
                                </div>

                                <div className="form-item">
                                    <label className="form-label" htmlFor="InputPhone">
                                        Ваш телефон*
                                    </label>
                                    <input
                                        className="form-control"
                                        name="phone"
                                        id="InputPhone"
                                        placeholder="+7 (___) ___-__-__"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        type="tel"
                                    />
                                    {errors.phone && <div className="text-danger">{errors.phone}</div>}
                                </div>

                                <div className="form-item">
                                    <label className="form-label" htmlFor="InputEmail">
                                        Ваш email*
                                    </label>
                                    <input
                                        className="form-control"
                                        name="email"
                                        id="InputEmail"
                                        placeholder="e-mail"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        type="email"
                                    />
                                    {errors.email && <div className="text-danger">{errors.email}</div>}
                                </div>

                                <input type="hidden" name="description" value={formData.description} />

                                <div className="form-item product-desc">{title}</div>

                                {colors.length > 0 && (
                                    <div className="form-item b-btn-radio js-color-block">
                                        <label className="form-label">Выберите цвет:</label>
                                        <div>
                                            {colors.map((color) => (
                                                <>
                                                    <span key={color.id}>
                                                        <input
                                                            type="radio"
                                                            className="btn-check"
                                                            name="options-color-modal"
                                                            id={`product_option_value_id_${color.id}`}
                                                            value={color.id}
                                                            checked={String(formData.color) === String(color.id)}
                                                            onChange={handleColorChange}
                                                        />
                                                        <label className="btn-color" htmlFor={`product_option_value_id_${color.id}`}>
                                                            <img src={color.imageUrl} alt={`Цвет ${color.id}`} />
                                                        </label>
                                                    </span>
                                                </>
                                            ))}
                                        </div>
                                        {errors.color && <div className="text-danger">{errors.color}</div>}
                                    </div>
                                )}

                                <div className="form-item form-check">
                                    <input
                                        className="form-check-input"
                                        name="agreement"
                                        id="Check3"
                                        type="checkbox"
                                        checked={formData.agreement}
                                        onChange={handleInputChange}
                                    />
                                    <label className="form-check-label" htmlFor="Check3">
                                        Я соглашаюсь с условиями обработки моих персональных данных
                                        <br />
                                        <a href="">Подробнее</a>
                                    </label>
                                    {errors.agreement && <div className="text-danger">{errors.agreement}</div>}
                                </div>

                                <button className="btn" type="submit" disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Загрузка...</span>
                                        </div>
                                    ) : (
                                        'Купить'
                                    )}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default OneClick;
